import React, { Component,useEffect, useState } from 'react';
import Spin from '../../../commonModules/interface/Spin.jsx';
import { BreadCrumb } from './containers/Layout.jsx';
import FormProduct from './products/FormProduct.jsx';
import ListProduct from './products/ListProduct.jsx';
import SingleProduct from './products/SingleProduct.jsx';
import { truncate } from "lodash";
import { Card, Grid, Button, Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import InputText, { InputSelect, InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import { BarChartOutlined, BarChartRounded, CenterFocusWeakRounded, CodeRounded, CropFreeRounded, MenuRounded, MoreVert, MultilineChartRounded, ShowChartRounded, TimelineRounded, TrendingUpRounded } from '@material-ui/icons';
import FormSubProduct from './products/SubProducts/FormSubProduct.jsx';
import ProductStats from './stats/ProductStats.jsx';
import GenerateQrCode from './products/GenerateQrCode.jsx';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEcomLinks } from '../../../../../../jsx/actions/settingsAction';
import { selectEcomActive } from '../../../../../../jsx/utils/ecomLinks';

const Products = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // Modules e-commerce masqués tant que le compte n'a aucune boutique jumelée active.
    const ecomActive = useSelector(selectEcomActive);
    useEffect(() => {
        dispatch(fetchEcomLinks());
    }, [dispatch]);

    const [state,setState] = useState({
        pageOfItems:[],
        currentPage:0,
        rowsPerPage:20,

        //Dialog
        dialogDesc:false,

        view : props.new ? "new" : "list",

        breadcrumb:"",
        update:false,
        sending: false,
        photos:{},
        reloadPagination: false,
        singleProd:{},
        openQR: false,
        single:{
            id: "",
            name: ""
        },
        anchorEl: null,
    })
      
        const openMenu = (event) => {
          setState(prevState => ({ ...prevState, anchorEl: event.currentTarget }));

        };
      
        const closeMenu = () => {
          setState(prevState => ({ ...prevState, anchorEl: null }));
        };
    
    // CLEAR & DISPLAY
        
    const handleSingle = (product) => {
        setState(prevState => ({...prevState,
                breadcrumb: product.name,
                singleProd:product,
                view: "product"
            }))
        }
        const handleUpdate = (product) => {
            console.log("in handle update")
            setState(prevState => ({...prevState,
                breadcrumb: product.name + " / Modifier",
                product:product,
                oldProduct:product,
                view: "update",
                anchorEl: null
            }))
            return
        }
        const handleSubProduct = (product) => {
            console.log("in handle sub")
            setState(prevState => ({...prevState,
                breadcrumb: product.name + " / Nouveau Sous Produit",
                product: product,
                oldProduct: product,
                view: "sub",
                anchorEl: null
            }))
            return
        }
        const handleRFIDGraph = (product) => {
            console.log("in handle RFID Graph", product)
            // Navigate to RFID Graph page with product_id filter
            // Use ../ to go up one level from /store to /adminpage
            navigate(`../rfid-graph?product_id=${encodeURIComponent(product.id)}`);
            setState(prevState => ({...prevState,
                anchorEl: null
            }))
            return
        }
        const handleNew = () => {
            setState(prevState => ({...prevState,
                view: "new", breadcrumb:"Nouveau"}))
        }
        const  handleClose = () => {
            console.log("[DEBUG] PRODUCTS HANDLE CLOSE")
            setState(prevState => ({...prevState,
                dialogDesc:false,
                singleProd:{},
                openQR: false,
                view: "list",
                breadcrumb:"",
                anchorEl: null
            }));
        }
        const handleCloseForm = () => {
            console.log("[DEBUG] PRODUCTS HANDLE CLOSE FORM")
            setState(prevState => ({...prevState,
                dialogDesc:false,
                breadcrumb: state.singleProd.name,
                view: "product",
                anchorEl: null
            }));
        }
        
        const onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        setState(prevState => ({...prevState,
            pageOfItems, currentPage, rowsPerPage }));
    }
   
        return(      
            <CardPage 
                title="Produits"
                storehouse
                action={
                    <div>
                        {state.view === "list" &&
                        <>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={ handleNew }
                        >
                            Nouveau
                        </Button>
                        </>
                        }
                        {state.view === "product" &&
                        <>
                            <IconButton 
                                color="secondary" 
                                size="medium"
                                onClick={() => setState(prevState => ({...prevState,openQR: true }))}
                                title="QR Code"
                            >
                                <CenterFocusWeakRounded />
                            </IconButton>
                            <IconButton 
                                color="secondary" 
                                size="medium"
                                onClick={() =>setState(prevState => ({...prevState,view: "stats" }))}
                                title="Statistiques"
                            >
                                <TimelineRounded />
                            </IconButton>
                            {/* <Button 
                                variant="contained"
                                color="secondary"
                                onClick={() => handleUpdate(state.singleProd)}
                            >
                                Modifier
                            </Button> */}
                            <IconButton 
                                aria-controls="simple-menu"
                                onClick={openMenu}
                            >
                                <MenuRounded />
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={state.anchorEl}
                                getContentAnchorEl={null}
                                keepMounted
                                open={Boolean(state.anchorEl)}
                                onClose={closeMenu}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={() => handleSubProduct(state.singleProd)}>Créer un sous-produit</MenuItem>
                                <MenuItem onClick={() => setState(prevState => ({...prevState,view: "stats" }))}>Statistiques</MenuItem>
                                <MenuItem onClick={() => handleUpdate(state.singleProd)}>Modifier</MenuItem>
                                <MenuItem onClick={() => handleRFIDGraph(state.singleProd)}>RFID-Graph</MenuItem>
                            </Menu>
                        </>
                        }
                    </div>
                }
            >
                {state.sending && <Spin />}
                
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Produits" back={state.view !== "update" ? handleClose : handleCloseForm} />
                
                {state.openQR &&
                    <GenerateQrCode 
                        // {...props} // notif from here
                        handleClose={() => setState(prevState => ({...prevState,openQR: false }))} 
                        product={state.singleProd}
                    />
                }
                {state.view === "new" &&
                    <FormProduct 
                        {...props} // notif from here
                        ecomActive={ecomActive}
                        handleClose={handleClose} 
                    />
                }
                {state.view === "sub" &&
                    <FormSubProduct 
                        {...props} // notif from here
                        handleClose={handleClose} 
                        handleCloseForm={handleCloseForm} 
                        MAIN_PRODUCT={state.product} 
                    />
                }
                {state.view === "update" &&
                    <FormProduct 
                        {...props} // notif from here
                        ecomActive={ecomActive}
                        handleClose={handleClose} 
                        product={state.product} 
                        oldProduct={state.oldProduct} 
                        update
                    />
                }
                {state.view === "stats" &&
                    <ProductStats 
                        {...props} 
                        close={handleCloseForm}
                        product={state.singleProd}
                    />
                }
                {state.view === "product" &&
                    <SingleProduct 
                        {...props} 
                        ecomActive={ecomActive}
                        close={handleClose}
                        product={state.singleProd}
                        updateDesc={()=> setState(prevState => ({...prevState, dialogDesc:true }))}
                        update={handleUpdate}
                    />
                }
                {state.view === "list" &&
                    <ListProduct 
                        {...props}
                        ecomActive={ecomActive}
                        {...state}
                        onChangePage={onChangePage}
                        handleSingle={handleSingle}
                        handleNew={handleNew}

                    />
                }
            </CardPage>
        )
}

export default Products

